"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementBox = void 0;

var _reactFeedback = require("@cimpress-technology/react-feedback");

var React = _interopRequireWildcard(require("react"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _reactComponents = require("@cimpress/react-components");

var _carousel = _interopRequireDefault(require("../carousel"));

var _i18n = require("../../hooks/i18n");

var _cimpressComponents = require("../../peer/cimpressComponents");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const defaultProps = {
  showInlineFeedback: false,
  showTopics: true
};

const renderAnnouncementTopics = (t, tags, topics) => {
  let formattedTopics;

  if (topics) {
    formattedTopics = topics.map(topic => /*#__PURE__*/React.createElement(_reactComponents.Label, _extends({}, _cimpressComponents.infoLabelProps, {
      key: topic,
      text: t(`topicNames_${topic}`)
    })));
  } else if (tags && tags.length) {
    formattedTopics = tags.map(({
      key,
      value = ''
    }) => /*#__PURE__*/React.createElement(_reactComponents.Label, _extends({}, _cimpressComponents.infoLabelProps, {
      key: key,
      text: value
    })));
  } // @ts-ignore


  return formattedTopics ? formattedTopics : null;
};

const renderAnnouncementWithTitleAndSnippet = (t, subAnnouncement, topics, tags, language, showTopics) => {
  const snippet = subAnnouncement.snippet ? subAnnouncement.snippet[language || 'en'] || subAnnouncement.snippet.en : 'snippet-n/a';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-child"
  }, /*#__PURE__*/React.createElement("h5", null, snippet)), /*#__PURE__*/React.createElement("div", {
    className: "flex-child-grow"
  }, "\xA0"), showTopics ? /*#__PURE__*/React.createElement("div", {
    className: "flex-child"
  }, renderAnnouncementTopics(t, tags || [], topics || [])) : null));
};

const AnnouncementBox = ({
  accessToken,
  language,
  announcement,
  showInlineFeedback,
  showTopics,
  // showReadMore,
  sessionId,
  multipleAnnouncements
}) => {
  var _announcement$title;

  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)(language);
  const [showLink, setShowLink] = React.useState(new Array(multipleAnnouncements.length).fill(false));
  const [showMessage, setShowMessage] = React.useState(new Array(multipleAnnouncements.length).fill(announcement.showDescription));
  const [indexPressed, setIndexPressed] = React.useState(0);
  const truncatedDescriptionBox = React.useRef([]);
  const expandedDescriptionBox = React.useRef([]);

  const checkImg = markdown => {
    const regex = /!\[(.*)\]\((.+)\)/g;
    const result = regex.exec(markdown);
    return result !== null;
  };

  React.useEffect(() => {
    const showLinkArr = new Array(multipleAnnouncements.length).fill(false);
    multipleAnnouncements.map((ann, i) => {
      let showLinkSet = 0;

      if (!showLinkArr[i] && checkImg(ann.content.en)) {
        showLinkArr[i] = !showLinkArr[i];
        showLinkSet = 1;
      }

      if (showMessage[i]) {
        expandedDescriptionBox.current[i].style.marginTop = checkImg(ann.content.en) ? '-4em' : `-${truncatedDescriptionBox.current[i].clientHeight}px`;
      } // based on whether the description content is short or long set the showLink state.
      // if true displays the Read More/Read Less link , else No links displayed


      if (!showLinkSet) {
        if (truncatedDescriptionBox.current[i].scrollHeight > truncatedDescriptionBox.current[i].clientHeight) {
          showLinkArr[i] = !showLinkArr[i];
        }
      }
    });
    setShowLink(showLinkArr);
  }, []);
  React.useEffect(() => {
    if (showMessage[indexPressed]) {
      expandedDescriptionBox.current[indexPressed].style.marginTop = `-${truncatedDescriptionBox.current[indexPressed].clientHeight}px`;
    }
  }, [showMessage]);

  const readMoreLink = (subAnnouncement, i) => {
    const content = subAnnouncement.content ? subAnnouncement.content[language || 'en'] || subAnnouncement.content.en : 'content-n/a';
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "container1",
      ref: el => truncatedDescriptionBox.current[i] = el,
      style: {
        maxHeight: '4em',
        overflowY: 'hidden',
        visibility: !showMessage[i] ? 'visible' : 'hidden'
      }
    }, /*#__PURE__*/React.createElement(_reactMarkdown.default, {
      source: content
    })), showMessage[i] && /*#__PURE__*/React.createElement("div", {
      ref: el => expandedDescriptionBox.current[i] = el,
      style: {
        overflowY: 'auto'
      }
    }, /*#__PURE__*/React.createElement(_reactMarkdown.default, {
      source: content
    })), showLink[i] ? /*#__PURE__*/React.createElement(_reactComponents.Button, _extends({}, _cimpressComponents.anchorButtonProps, {
      style: {
        paddingTop: '10px'
      },
      onClick: () => {
        const newArray = [...showMessage];
        newArray[i] = !newArray[i];
        setIndexPressed(i);
        setShowMessage(newArray);
      }
    }), showMessage[i] ? tt('readLessAllAnnouncementsLink') : tt('readMoreAllAnnouncementsLink')) : null);
  };

  const renderSubAnnouncement = (subAnnouncement, i = 0) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "loudspeakerAnnouncement"
    }, /*#__PURE__*/React.createElement("div", {
      className: "snippet-container"
    }, renderAnnouncementWithTitleAndSnippet(tt, subAnnouncement, announcement.topics, announcement.tags, language, showTopics)), /*#__PURE__*/React.createElement("div", {
      className: "flex-container"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      }
    }, readMoreLink(subAnnouncement, i)), /*#__PURE__*/React.createElement("div", {
      className: "flex-child-grow"
    }, "\xA0")));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, multipleAnnouncements.length === 1 ? renderSubAnnouncement(multipleAnnouncements[0]) : /*#__PURE__*/React.createElement("div", {
    className: "carousel-wrapper"
  }, /*#__PURE__*/React.createElement(_carousel.default, {
    minimal: true
  }, multipleAnnouncements.map((ann, i) => renderSubAnnouncement(ann, i)))), /*#__PURE__*/React.createElement("div", null, showInlineFeedback ? /*#__PURE__*/React.createElement(_reactFeedback.InlineFeedback, {
    accessToken: accessToken,
    language: language,
    campaignId: "e6bfa058-11df-11eb-a2bb-0a6d98ccf6f1",
    questionId: "f3061824-11df-11eb-a2bb-0a6d98ccf6f1",
    extraFeedbackData: {
      announcementId: announcement.announcementId,
      announcementTitle: ((_announcement$title = announcement.title) === null || _announcement$title === void 0 ? void 0 : _announcement$title.en) || ''
    },
    sessionId: sessionId
  }) : null));
};

exports.AnnouncementBox = AnnouncementBox;
AnnouncementBox.defaultProps = defaultProps;